<template>
  <div>
    <template v-for="item in visibleMenuItems" :key="item.id">
      <DxButton :text="item.text" @click="menuChange(item.id)" :styling-mode="'text'" :icon="item.icon" />
      <br>
    </template>

  </div>
</template>

<script>

import DxButton from 'devextreme-vue/button';
import R3DetailsInfo from "@/components/container/container-details-info.vue";
import R3DetailsAnalytics from "@/components/container/container-details-analytics.vue";
import R3DetailsSpecifics from "@/components/container/container-details-specifics.vue";
import R3DetailsNotes from "@/components/container/container-details-notes.vue";
import R3DetailsRequests from "@/components/container/container-details-requests.vue";
import R3DetailsDevice from "@/components/container/container-details-device.vue";
import R3DetailsChange from "@/components/container/container-details-audit.vue";

export default {
  components: {
    DxButton
  },
  props: {
    isOperator: {
      type: Boolean,
      default: false,
    },
    selectedMenuIndex: {
      type: Number,
      default: null,
    },
  },
  created() { },
  data() {
    return {
      menuItems: [
        { id: 0, text: 'Info', icon: 'info', component: R3DetailsInfo, visibleForOperator: true, visibleForDefault: true },
        { id: 1, text: 'Details', icon: 'detailslayout', component: R3DetailsSpecifics, visibleForOperator: true,visibleForDefault: true },
        { id: 2, text: 'Trends', icon: 'chart', component: R3DetailsAnalytics, visibleForOperator: true, visibleForDefault: true },
        { id: 3, text: 'Notes', icon: 'comment', component: R3DetailsNotes, visibleForOperator: false, visibleForDefault: true },
        { id: 4, text: 'Requests', icon: 'file', component: R3DetailsRequests, visibleForOperator: false, visibleForDefault: true },
        { id: 5, text: 'Device', icon: 'preferences', component: R3DetailsDevice, visibleForOperator: false, visibleForDefault: false },
        { id: 6, text: 'Audit', icon: 'clock', component: R3DetailsChange, visibleForOperator: false, visibleForDefault: false }
      ]
    };
  },
  computed: {
    visibleMenuItems() {
      var m = this.menuItems
      var o = this.menuItems.filter(item => item.visibleForOperator)
      var d = this.menuItems.filter(item => item.visibleForDefault)
      // admin get all menu items
      if (this.userInfo.Admin=="1")
        return m
      //operator view
      if (this.isOperator)
        return o
      //return default
      return d      
    },
    userInfo() {
      var profile = this.$store.getters["auth/getTokenDetails"];
      if (profile == undefined || profile == null)
        return ""
      else
        return profile
    }
  },
  methods: {
    menuChange(menuIndex) {
      const selectedItem = this.visibleMenuItems.find(item => item.id === menuIndex);
      this.$emit('menu-change', {
        index: menuIndex,
        component: selectedItem.component
      });
    }
  }
};

</script>

<style scoped></style>
